<template>
    <!-- Start Boxes Area -->
    <section class="boxes-area">
        <div class="container">
            <div class="boxes-slides">
                <carousel 
                    :autoplay = "true" 
                    :loop = "true"
                    :autoplaySpeed = "true"
                    :paginationEnabled = "false"
                    :autoplayTimeout = "5000"
                    :perPageCustom = "[[0, 1],[576, 2],[768, 2],[1200, 4], [1500, 5]]"
                >
                    <!--<slide>
                        <div class="single-box">
                            <div class="icon">
                                <feather type="airplay"></feather>
                            </div>
                            <h3>Fully Customizable</h3>
                            <p>Lorem ipsum dolor sit amet elit, adipiscing, sed do eiusmod tempor incididunt ut labore dolore magna.</p>
                        </div>
                    </slide>-->
                    
                    <slide>
                        <div class="single-box bg-f78acb">
                            <div class="icon">
                                <feather type="arrow-up-right"></feather>
                            </div>
                            <h3>Raising awareness</h3>
                            <p>Shed light on what drives your business model assumptions and get an overview about what influences your guess.</p>
                        </div>
                    </slide>

                    <slide>
                        <div class="single-box bg-c679e3">
                            <div class="icon">
                                <feather type="user"></feather>
                            </div>
                            <h3>Human-centered</h3>
                            <p>We've put the human back into the equation. Business model design is all about us: Human beings.</p>
                        </div>
                    </slide>

                    <slide>
                        <div class="single-box bg-eb6b3d">
                            <div class="icon">
                                <feather type="star"></feather>
                            </div>
                            <h3>Hyper-dynamic</h3>
                            <p>We believe in easy to use tools instead of canvas models which are not appropriate to new dynamic environments.</p>
                        </div>
                    </slide>
                    
                    <slide>
                        <div class="single-box bg-eb6b3d">
                            <div class="icon">
                                <feather type="edit-2"></feather>
                            </div>
                            <h3>Start Designing</h3>
                            <p>Everyone can be a business model designer - let's start educating your guess and design your business model.</p>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>
    </section>
    <!-- End Boxes Area -->
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'BoxesArea',
    components: { Carousel, Slide }
}
</script>